module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/izabela-kowalczyk-460bf490d895a8c72b7b9a4cf47e66b7.webp";